var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.90001C6.75 5.65149 6.95148 5.45001 7.2 5.45001C7.44852 5.45001 7.65 5.65149 7.65 5.90001V9.50001C7.65 9.74853 7.44852 9.95001 7.2 9.95001C6.95148 9.95001 6.75 9.74853 6.75 9.50001V5.90001Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2 0.0499878C10.7622 0.0499878 13.65 2.93775 13.65 6.49999C13.65 10.0622 10.7622 12.95 7.2 12.95C3.63774 12.95 0.75 10.0622 0.75 6.49999C0.75 2.93775 3.63774 0.0499878 7.2 0.0499878ZM12.75 6.49999C12.75 3.43481 10.2652 0.949988 7.2 0.949988C4.13484 0.949988 1.65 3.43481 1.65 6.49999C1.65 9.56515 4.13484 12.05 7.2 12.05C10.2652 12.05 12.75 9.56515 12.75 6.49999Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 4.1C6.6 4.43137 6.86862 4.7 7.2 4.7C7.53138 4.7 7.8 4.43137 7.8 4.1C7.8 3.76863 7.53138 3.5 7.2 3.5C6.86862 3.5 6.6 3.76863 6.6 4.1Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.eadafd8ed390bbdff7e0fb25cee9037d.svg";
export { ForwardRef as ReactComponent };